import React from 'react';
import BookForm from '../components/BookForm';
import Navbar from '../components/Navbar';

const AddPage = () => {
  return (
    <>
      <Navbar />
      <BookForm />
    </>
  );
};

export default AddPage;
